'use client';
import React from 'react';
import Image from 'next/image';
import { MODAL_TYPES, useModal } from './ModalProvider';

export default function BenefitModalWrapper({
  isOpen,
  onClose,
  icon,
  description,
  title,
  productModal,
  modalIcon
}) {
  const { modalUtils, getCloseButton } = useModal();

  return modalUtils.createModalWrapper({
    modalType: MODAL_TYPES.benefit,
    isOpen,
    onClose,
    containerClassName: modalUtils.containerPresets.standard.basic,
    children: (
      <>
        {getCloseButton(MODAL_TYPES.benefit, onClose)}

        {productModal && modalIcon ? (
          <Image
            src={modalIcon?.url}
            alt={modalIcon?.title?.replace(/\.[^/.]+$/, '') || ''}
            width="60"
            height="60"
            sizes="60px"
            className="mb-6 brightness-0 grayscale"
          />
        ) : (
          <Image
            src={icon?.url}
            alt={icon?.title?.replace(/\.[^/.]+$/, '') || ''}
            width="60"
            height="60"
            sizes="60px"
            className="mb-6 brightness-0 grayscale"
          />
        )}

        <span className="sh9 mb-4 block text-black">{title}</span>
        <p className="body-r text-black">{description}</p>
      </>
    )
  });
}
